import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import TextField from '@mui/material/TextField'
import Close from 'mdi-material-ui/Close'
import Magnify from 'mdi-material-ui/Magnify'

const UserToolbar = props => {
    const { value, onChange, clearSearch } = props

    return (
        <Box
            sx={{
                p: 2,
                pb: 0,
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                flexDirection: 'row-reverse'
            }}
        >
            <Box sx={{ display: 'flex' }}>
                <TextField
                    variant='standard'
                    value={value}
                    onChange={onChange}
                    placeholder='고객이름 검색..'
                    InputProps={{
                        startAdornment: <Magnify fontSize='small' />,
                        endAdornment: (
                            <IconButton size='small' title='Clear' aria-label='Clear' onClick={clearSearch}>
                                <Close fontSize='small' />
                            </IconButton>
                        )
                    }}
                    sx={{
                        width: {
                            xs: 1,
                            sm: 'auto'
                        },
                        m: theme => theme.spacing(1, 0.5, 1.5),
                        '& .MuiSvgIcon-root': {
                            mr: 0.5
                        },
                        '& .MuiInput-underline:before': {
                            borderBottom: 1,
                            borderColor: 'divider'
                        }
                    }}
                />
            </Box>
        </Box>
    )
}

export default UserToolbar
